import type { UserTenantPropertiesResponse } from 'dynamo-wrapper';
import { isOpenAccess } from 'lib/openAccessUtil';
import { tenantQueryKeys } from 'queries/queryKeys/tenantKeys';
import { useQuery, type UseQueryOptions } from 'react-query';
import { GetTenantUserProperties } from 'services/UserService';

export const useTenantProperties = <T = UserTenantPropertiesResponse>(
    options: Omit<UseQueryOptions<UserTenantPropertiesResponse, unknown, T, string[]>, 'cacheTime' | 'staleTime'>
) => {
    return useQuery(tenantQueryKeys.tenantProperties, ({ signal }) => GetTenantUserProperties(signal), {
        ...options,
        cacheTime: Number.POSITIVE_INFINITY,
        staleTime: Number.POSITIVE_INFINITY,
        enabled: (options?.enabled ?? true) && !isOpenAccess()
    });
};
